import { actionCreatorFactory } from 'typescript-fsa';
import type { IApiErrorParams } from '@cbridge-packages/api';
import type { ISpreadProfile } from './spreadProfile.interface';

export namespace SpreadProfileAction {
  const actionCreator = actionCreatorFactory('SpreadProfile');

  export const loadList = actionCreator.async<void, ISpreadProfile[], IApiErrorParams>('LOAD_LIST');

  interface ISpreadProfileRemoveParams {
    id: ISpreadProfile['id'];
  }

  export const create = actionCreator.async<ISpreadProfile, ISpreadProfile, IApiErrorParams>('CREATE');
  export const update = actionCreator.async<ISpreadProfile, void, IApiErrorParams>('UPDATE');
  export const remove = actionCreator.async<ISpreadProfileRemoveParams, void, IApiErrorParams>('REMOVE');

  export const destroy = actionCreator('DESTROY');
}
